/**
 * Срез «все сайты» в «Аналитике» раздела EO «Виджет» (01.11, ТЗ 1.17 EMB-019 ч. 4): сумма чисел сайтов (сами числа считает сервер
 * функцией сводки OPS-006 — здесь только сложение) и сумма воронки сводок. p75 окон не складывается: среднее и худшее окно.
 * Чистые функции, тест — widgetModels.test.ts.
 */
import type { DiagSite, SiteCounts } from "./widgetTypes";

/** Поключевая сумма словарей счётчиков. */
export function sumRec<K extends string>(list: readonly Record<K, number>[]): Record<K, number> {
  const out = {} as Record<K, number>;
  for (const r of list) for (const [k, n] of Object.entries(r) as [K, number][]) out[k] = (out[k] ?? 0) + (Number(n) || 0);
  return out;
}

/** Числа V4 всех сайтов одной строкой. */
export function totalCounts(list: readonly SiteCounts[]): SiteCounts {
  const sum = (f: (s: SiteCounts) => number) => list.reduce((a, s) => a + f(s), 0);
  return { id: 0, domain: "все сайты", live: list.some((s) => s.live), shown: list.some((s) => s.shown), post: sumRec(list.map((s) => s.post)),
    kinds: sumRec(list.map((s) => s.kinds)), hp: sum((s) => s.hp), requests: sum((s) => s.requests), booked: sum((s) => s.booked), tracked: sum((s) => s.tracked) };
}

/** Воронка сводок всех сайтов (или одного) одной строкой; нет строк — null («нет данных»). */
export function totalDiag(list: readonly DiagSite[]): DiagSite | null {
  if (!list.length) return null;
  const avgs = list.map((d) => d.tap_p75_avg).filter((x): x is number => x !== null), maxes = list.map((d) => d.tap_p75_max).filter((x): x is number => x !== null);
  return { site_id: list.length === 1 ? list[0]!.site_id : null, open: list.reduce((a, d) => a + d.open, 0), req: list.reduce((a, d) => a + d.req, 0),
    submit: sumRec(list.map((d) => d.submit)), fallback: sumRec(list.map((d) => d.fallback)), api: {},
    tap_p75_avg: avgs.length ? Math.round(avgs.reduce((a, b) => a + b, 0) / avgs.length) : null, tap_p75_max: maxes.length ? Math.max(...maxes) : null };
}
